export default {
  TOKEN: "2a892ff6c5f68a12a980bb501b7cf9dc6babd33a",
};
